import type { Clip } from "@hudhud/core";
import { COLORS, WIDTH } from "../types.js";
import { clampMap } from "./interpolate.js";
import { spring } from "./spring.js";
import { CARD_BG, type RadialBg } from "./opener.js";

export const END_BG: Record<Clip["endCard"]["bg"], RadialBg> = CARD_BG;
export const END_FLAT: Record<Clip["endCard"]["bg"], string> = { green: COLORS.green, ink: COLORS.ink, gold: COLORS.gold, white: COLORS.offWhite };

export interface EndEnter { enter: number; opacity?: number; ty?: number; scale?: number }
/** The card's entrance `frame` frames in: a spring for rise / zoom, a short fade, or nothing. */
export function endEnter(animation: Clip["endCard"]["animation"], frame: number, fps: number): EndEnter {
  const s = spring({ frame, fps, config: { damping: 14, stiffness: 140 } });
  const fade = clampMap(frame, [0, 8], [0, 1]);
  const enter = animation === "none" ? 1 : animation === "fade" ? fade : s;
  if (animation === "rise") return { enter, opacity: s, ty: (1 - s) * 40 };
  if (animation === "zoom") return { enter, opacity: s, scale: 1.1 - 0.1 * s };
  if (animation === "fade") return { enter, opacity: fade };
  return { enter };
}
/** A pill button that settles, then breathes so the eye lands on it. */
export const buttonPulse = (frame: number) => 1 + 0.02 * Math.sin(Math.max(0, frame - 20) / 6);
/** The huge handle of the "type" card, sized to fit its length. */
export const typeHandleSize = (handle: string, scale: number) => Math.round(Math.min(220, (WIDTH - 120) / Math.max(4, handle.length) * 1.9) * scale);
